export interface Drawer {
    loading: boolean;
    visible: boolean;
}

export const DefaultDrawer = () => {
    return {
        loading: false,
        visible: false
    } as Drawer;
}
